/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Indicates for a DMA if it is a generic library DMA cases or specific customer DMA case
 */
export enum DmaCaseType {
  GENERIC = 'Generic',
  SPECIFIC = 'Specific',
}
